function SmileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="28px"
      viewBox="0 -960 960 960"
      width="28px"
      fill="#FCB96B"
    >
      <path d="M627.88-512q29.12 0 49.62-20.38 20.5-20.38 20.5-49.5t-20.38-49.62q-20.38-20.5-49.5-20.5t-49.62 20.38q-20.5 20.38-20.5 49.5t20.38 49.62q20.38 20.5 49.5 20.5Zm-296 0q29.12 0 49.62-20.38 20.5-20.38 20.5-49.5t-20.38-49.62q-20.38-20.5-49.5-20.5t-49.62 20.38q-20.5 20.38-20.5 49.5t20.38 49.62q20.38 20.5 49.5 20.5ZM480-240q75.6 0 137.3-43Q679-326 704-398h-84q-22.32 37.92-59.35 59.96T480-316q-43.62 0-80.65-22.04Q362.32-360.08 340-398h-84q25 72 86.7 115T480-240Zm0 192q-89.64 0-168.48-34.02-78.84-34.02-137.16-92.34-58.32-58.32-92.34-137.16T48-480q0-89.64 34.02-168.48 34.02-78.84 92.34-137.16 58.32-58.32 137.16-92.34T480-912q89.64 0 168.48 34.02 78.84 34.02 137.16 92.34 58.32 58.32 92.34 137.16T912-480q0 89.64-34.02 168.48-34.02 78.84-92.34 137.16-58.32 58.32-137.16 92.34T480-48Zm0-432Zm0 326q136 0 231-95t95-231q0-136-95-231t-231-95q-136 0-231 95t-95 231q0 136 95 231t231 95Z" />
    </svg>
  );
}

export default SmileIcon;
